import DragNDrop from '@sharedComponent/drag-drop';
import { Col, Row } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import './employeesheet.scss';
import ButtonComponent from './../../button/index';
import { useHistory } from 'react-router-dom';
import selectors from './selectors';
import Actions from './action.js';
import { connect } from 'react-redux';
import ErrorTable from '@sharedComponent/error-table';
import FadeIn from '@sharedComponent/animated-component';
import DotLoader from 'react-spinners/DotLoader';

const Employeesheet = ({
	postemployeeStart,
	employee,
	data,
	employeeData,
	uploaded,
	getsalarytemplateStart,
	postapiStatus,
	isEmployeeLoading,
	isUploadbuttonData,
	isUploadLoading,
}) => {
	const [file, setFile] = useState(false);
	const history = useHistory();
	console.log(file, !employeeData?.validationMessage, isUploadbuttonData, 'label');
	return (
		<div>
			{' '}
			<Col className="employee" xl={24} lg={24} md={24} sm={24} xs={24}>
				<p className="title">Upload Employee Spreadsheet</p>
				<div className="list">
					<div className="number">
						<span className="value">1</span>
					</div>
					<div className="list-text">
						<span>
							Download our new salary template{' '}
							<a
								onClick={() => {
									getsalarytemplateStart();
								}}>
								Here.
							</a>
						</span>
					</div>
				</div>
				<div className="list">
					<div className="number">
						<span className="value">2</span>
					</div>
					<div className="list-text">Fill in your details in the template and upload it below</div>
				</div>
				<div className="list">
					<div className="number">
						<span className="value">3</span>
					</div>
					<div className="list-text"> For all employee who have C3Pay Card selected, cards will be delivered within 5-7 working days</div>
				</div>

				<DragNDrop
					uploaded={file}
					setUploaded={setFile}
					postemployeeStart={postemployeeStart}
					employeeData={employeeData}
					uploadLoading={isUploadLoading}
				/>
				{file && employeeData?.validationMessage ? (
					<FadeIn delay={0.5} style={{ height: 'unset' }}>
						<Fragment>
							<Col xl={24} md={24} sm={24} lg={24} xs={24} className="card_error">
								<ErrorTable
									data={employeeData && employeeData.validationMessage}
									// loadErrorData={loadErrorData}
									// enableNextButton={enableNextButton}
								/>
							</Col>
						</Fragment>
					</FadeIn>
				) : (
					''
				)}

				<Col xl={9} lg={24} md={24} sm={24} xs={24} className="submit-button">
					<ButtonComponent
						className={file && !employeeData?.validationMessage && isUploadbuttonData === 'success' ? 'order' : ' disablebutton'}
						onClick={() => {
							history.push({
								pathname: '/employeedetais',
								state: {
									employee: { employee },
									edit: 'select',
								},
							});
						}}>
						Submit
					</ButtonComponent>
				</Col>
				<button
					className="goback"
					onClick={() => {
						history.push('/user/Order-cards');
					}}>
					Go Back
				</button>
			</Col>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		employeeData: selectors.employeeData(state),
		isEmployeeLoading: selectors.isEmployeeLoading(state),
		salarytemplateData: selectors.salarytemplateData(state),
		isSalaryTemplateLoading: selectors.isSalaryTemplateLoading(state),
		postapiStatus: selectors.uploadData(state),
		isUploadbuttonData: selectors.isUploadbuttonData(state),
		isUploadLoading: selectors.isUploadLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		postemployeeStart: (params) => dispatch(Actions.creators.postuploadStart(params)),
		getsalarytemplateStart: (params) => dispatch(Actions.creators.getsalarytemplateStart(params)),
	};
};

const Connection = connect(mapStateToProps, mapDispatchToProps)(Employeesheet);

export default Connection;
